<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row v-if="loaded" class="mx-0 mb-3">
      <b-col>
        <b-card class="shadow bg-light">
          <b-row>
            <b-col lg="12" class="mb-3">
              <b-button
                class="mr-3"
                target="_blank"
                :href="pdf"
                size="sm"
                icon
                variant="secondary"
                title="PDF du relevé"
                ><b-icon-printer-fill></b-icon-printer-fill
              ></b-button>
              <b-button @click="$bvModal.show('email-account')" size="sm" icon
                ><b-icon-envelope-fill></b-icon-envelope-fill
              ></b-button>
            </b-col>
            <b-col lg="12">
              <b-card class="mb-2 shadow bg-light">
                <b-row>
                  <mh-input
                    mh-class="col-3"
                    field="ID"
                    :readonly="!edit"
                    :table="releveCompte"
                  ></mh-input>
                  <mh-input
                    mh-class="col-3"
                    field="date_creation"
                    :readonly="!edit"
                    :table="releveCompte"
                  ></mh-input>
                  <mh-input
                    mh-class="col-3"
                    field="creancier"
                    readonly
                    :table="releveCompte"
                  ></mh-input>
                  <mh-input
                    mh-class="col-3"
                    field="report"
                    :readonly="!edit"
                    :table="releveCompte"
                    append="€"
                  ></mh-input>
                  <mh-input
                    mh-class="col-3"
                    field="totalCreancier"
                    :readonly="!edit"
                    :table="releveCompte"
                    append="€"
                  ></mh-input>
                  <mh-input
                    mh-class="col-3"
                    field="totalChezNous"
                    :readonly="!edit"
                    :table="releveCompte"
                    append="€"
                  ></mh-input>
                  <mh-input
                    mh-class="col-3"
                    field="totalChezVous"
                    :readonly="!edit"
                    :table="releveCompte"
                    append="€"
                  ></mh-input>
                  <mh-input
                    mh-class="col-3"
                    field="balance"
                    :readonly="!edit"
                    :table="releveCompte"
                    append="€"
                  ></mh-input>
                  <mh-input
                    mh-class="col-3"
                    field="regularised"
                    :readonly="!edit"
                    :table="releveCompte"
                  ></mh-input>
                  <mh-input
                    mh-class="col-12"
                    field="note"
                    :readonly="!edit"
                    :table="releveCompte"
                    labelColsLg="1"
                  ></mh-input>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-modal
        title="Envoyer le relevé de compte par mail"
        id="email-account"
        size="lg"
        title-class="text-center"
        hide-footer
      >
        <AccountStatementMail
          @close="$bvModal.hide('email-account')"
          object="relevé"
          :releve_id="releveCompte.ID.value"
        ></AccountStatementMail>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import MhInput from "@/components/MhInput.vue";
import accountStatements from "@/services/account-statements";
import AccountStatementMail from "@/components/AccountStatementMail";
export default {
  name: "account-statement-view",
  components: { MhInput, AccountStatementMail },
  computed: {
    pdf() {
      return (
        this.$store.getters.url +
        "/api/account-statement/" +
        this.releveCompte.ID.value +
        "/pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
  },
  data() {
    return {
      edit: false,
      loaded: false,
      releveCompte: {},
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Relevés de compte",
          to: { name: "account-statements" },
        },
      ],
    };
  },
  beforeCreate() {
    accountStatements.get(this.$route.params.id).then((response) => {
      this.releveCompte = response.data;
      this.items.push({
        text: "Relevé de compte n° " + this.releveCompte.ID.value,
        active: true,
      });
      this.loaded = true;
    });
  },
};
</script>

<style lang="scss" scoped>
</style>